import { Component } from "react";

/**
 * Tiny error boundary so a single child crash doesn't take down the whole tile.
 * Logs once to console so dev-time issues are still discoverable, then renders
 * a small inline fallback that the user can dismiss / retry with.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info?.componentStack);
  }
  reset = () => this.setState({ error: null });
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="error-boundary-fallback" style={{
        padding: 16,
        borderRadius: 12,
        background: "rgba(239,68,68,0.08)",
        border: "1px solid rgba(239,68,68,0.28)",
        color: "var(--text)",
        fontSize: 13,
        lineHeight: 1.5,
      }}>
        <div style={{ fontWeight: 800, color: "#fca5a5", marginBottom: 6 }}>
          {this.props.label || "Component error"}
        </div>
        <div style={{ opacity: 0.8, marginBottom: 10, fontSize: 12 }}>
          {String(this.state.error?.message || this.state.error || "Unknown error").slice(0, 240)}
        </div>
        <button onClick={this.reset} style={{
          padding: "6px 12px", borderRadius: 8,
          background: "rgba(96,165,250,0.18)",
          border: "1px solid rgba(96,165,250,0.4)",
          color: "#60a5fa", fontSize: 12, fontWeight: 700, cursor: "pointer",
        }}>Retry</button>
      </div>
    );
  }
}
